import { AbsolutePath } from '@/types/navigation';
import { BackendEndpointsKeys } from '@/types/network';

export const HTTP_STATUSES = {
  notFound: 404,
} as const;

export const BACKEND_ENDPOINTS: Record<BackendEndpointsKeys, AbsolutePath> = {
  articleFeedback: '/forms/v1/docs_feedback',
  searchFeedback: '/searchforms/v1/search_feedback',
  serpFilters: '/facade/v3/filters',
  searchArticles: '/facade/v4/search',
  oidcLoginState: '/login/state',
};
